/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

export const SearchFieldWrapper = styled.div<{ width?: string }>`
  width: ${({ width }) => width || `${gridSize() * 23}px`};
  ${media.upToMedium(`
    width: 100%;
  `)}

  ${media.upToSmall(`
    margin-top: ${gridSize()}px;
  `)}

  button {
    height: auto;
  }
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  margin-right: 6px;
`;

export const ClearFilterButton = styled(Button)`
  margin-right: 6px;
`;

export const SearchFieldAligner = styled.div`
  margin-bottom: ${gridSize() * 1.5}px;
  margin-right: ${gridSize()}px;
  ${media.upToMedium(`
    width: 100%;
    margin-right: 0;
  `)}
`;
